import Nullstack from 'nullstack';
export default function IconCreditCard({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-credit-card",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "3"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "15",
    x2: "7.01",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "15",
    x2: "13",
    y2: "15"
  }), " ");
}